import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getActiveDirectoryId } from '../../../directory/selectors';
import * as selectors from '../../selectors';
import * as actions from '../../actions';

import presenter from './presenter';

const mapStateToProps = createStructuredSelector({
  directoryId: getActiveDirectoryId,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(presenter);
